import { createEffect, sample } from 'effector';
import _ from 'lodash';
import $$api from 'models/api';
import { $global } from 'models/store-global';

import AlertsService from 'services/AlertsService';

import { MyStore } from 'types/Store';

sample({
    clock: [
        $$api.answers.autofillAnswersFx.failData,
        $$api.answers.deleteAnswersFx.failData,
        $$api.answers.getAnswersFx.failData,
        $$api.answers.getCommonAnswersFx.failData,
        $$api.answers.putAnswersFx.failData,
    ],
    target: createEffect(AlertsService.handleError),
});

sample({
    source: $global,
    clock: $$api.answers.getAnswersFx.done,
    fn: (store, { params, result }): MyStore => {
        const { id, path } = params;
        let answers;
        if (path) {
            answers = _.cloneDeep(store.answers?.[id] || {});
            _.set(answers, path, result);
        } else {
            answers = result;
        }
        return {
            ...store,
            answers: {
                ...(store.answers || {}),
                [id]: answers,
            },
        };
    },
    target: $global,
});

sample({
    source: $global,
    clock: $$api.answers.putAnswersFx.done,
    fn: (store, { params }): MyStore => {
        const { id, path } = params;
        let answers;
        if (path) {
            answers = _.cloneDeep(store.answers?.[id] || {});
            _.set(answers, path, params.answers);
        } else {
            answers = params.answers;
        }
        return {
            ...store,
            answers: {
                ...(store.answers || {}),
                [id]: answers,
            },
        };
    },
    target: $global,
});

sample({
    source: $global,
    clock: $$api.answers.getCommonAnswersFx.doneData,
    fn: (store, data): MyStore => ({
        ...store,
        commonAnswers: data,
    }),
    target: $global,
});

sample({
    source: $global,
    clock: $$api.answers.deleteAnswersFx.done.map(({ params }) => params),
    fn: (global, { id, path }) => {
        delete global.answers?.[id]?.[path];
        return global;
    },
    target: $global,
});
